module.exports = __webpack_public_path__ + "static/media/ma_ruletaExpress.c512ce51.png";